export const c2cBenifits = [
    "6L+ Verified buyers",
    "Competitive pricing",
    "Control and transparency"
];

export const JOURNEY_STATUS = {
    PITCHED: "PITCHED",
    DELISTED: "DELISTED",
    REJECTED: "QC_REJECTED",
    SOLD: "SOLD",
    SOLD_WITHOUT_SPP: "SOLD_WITHOUT_SPP"
};

export const marketPlaceBaseUrl = "/marketplace/";
